import { DataItemMap, ProductionData } from "../../types/responseTypes";

// Mock hourly production data for testing purposes
//
// correponde al ejemplo entregado en la documentación del backend
const mockDailyData: ProductionData[] = [
      {
        collectTime: 1730433600000,
        stationCode: "NE=33999642",
        dataItemMap: {
          inverter_power: 6.64,
          inverterYield: 6.64,
          selfUsePower: 1.89,
          reduction_total_tree: 0.004,
          power_profit: 800.9,
          PVYield: 6.64,
          perpower_ratio: 2.012,
          reduction_total_co2: 0.003,
          selfProvide: 1.89,
          installed_capacity: 3.3,
          use_power: 5.63,
          reduction_total_coal: 0.003,
          ongrid_power: 4.75,
          buyPower: 3.74,
        } as DataItemMap,
      },
      {
        collectTime: 1730520000000,
        stationCode: "NE=33999642",
        dataItemMap: {
          inverter_power: 14.21,
          inverterYield: 14.21,
          selfUsePower: 1.76,
          reduction_total_tree: 0.009,
          power_profit: 1508.35,
          PVYield: 14.21,
          perpower_ratio: 4.306,
          reduction_total_co2: 0.007,
          selfProvide: 1.76,
          installed_capacity: 3.3,
          use_power: 6.33,
          reduction_total_coal: 0.006,
          ongrid_power: 12.45,
          buyPower: 4.57,
        } as DataItemMap,  
      }, 
      {
        collectTime: 1730606400000,
        stationCode: "NE=33999642",
        dataItemMap: {
          inverter_power: 6.43,
          inverterYield: 6.43,
          selfUsePower: 4.87,
          reduction_total_tree: 0.004,
          power_profit: 1049.15,
          PVYield: 6.43,
          perpower_ratio: 1.948,
          reduction_total_co2: 0.003,
          selfProvide: 4.87,
          installed_capacity: 3.3,
          use_power: 18.3,
          reduction_total_coal: 0.003,
          ongrid_power: 1.56,
          buyPower: 13.43,
        } as DataItemMap,
      },
  ];

export default mockDailyData;